import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Hero = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Fonction pour le scroll fluide (à utiliser dans le Hero)
  const scrollToSection = (sectionId) => {
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    // Vérifier si on vient d'une autre page avec une section cible
    if (location.hash) {
      const sectionId = location.hash.replace('#', '');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          window.scrollTo({
            top: element.offsetTop - 80,
            behavior: 'smooth'
          });
        }
      }, 100); // Petit délai pour le chargement
    }
    
    // Vérifier sessionStorage pour le scroll (venant du Header)
    const scrollToSection = sessionStorage.getItem('scrollToSection');
    if (scrollToSection) {
      setTimeout(() => {
        const element = document.getElementById(scrollToSection);
        if (element) {
          window.scrollTo({
            top: element.offsetTop - 80,
            behavior: 'smooth'
          });
        }
        sessionStorage.removeItem('scrollToSection');
      }, 300);
    }
  }, [location]);

  return (
    <section className="relative h-screen overflow-hidden bg-black">
      {/* Conteneur vidéo */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          disablePictureInPicture
          className="w-full h-full object-cover scale-105"
        >
          <source src="/videos/providence_background.mp4" type="video/mp4" />
          <div className="absolute inset-0 bg-gradient-to-br from-[#1E3A8A] via-[#2C3E50] to-[#0F1A3A]"></div>
        </video>

        {/* <img
          src="/images/prov_skylinee.jpg"
          alt="Providence Rhode Island Skyline"
          className="w-full h-full object-cover"
        /> */}
        
        {/* Overlay pour le texte */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Contenu CENTRÉ */}
      <div className="relative z-10 h-full flex items-center justify-center text-center">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          
          {/* SLOGAN PRINCIPAL */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-white mb-6 leading-tight tracking-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Operational Excellence, Delivered Nationwide
          </h1>

          {/* Sous-titre existant */}
          <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-2xl mx-auto font-light leading-relaxed">
            A nationwide government contractor delivering Facility Management, Professional Services, and Base Operations Support on time and on standard
          </p>

          {/* Bouton centré */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => scrollToSection('services')}
              className="inline-flex items-center justify-center px-8 py-3 bg-[#C5A047] text-white font-medium rounded-full hover:bg-[#D4AF37] transition-colors transform hover:scale-105 duration-300"
            >
              <span className="text-lg">VIEW SERVICES</span>
              <svg className="ml-3 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
              </svg>
            </button>

            {/* CONTACT US CTA */}
            <button
              onClick={() => navigate("/contact")}
              className="inline-flex items-center justify-center px-8 py-3 bg-[#C5A047] text-white font-medium rounded-full hover:bg-[#D4AF37] transition-colors transform hover:scale-105 duration-300"
            >
              <span className="text-lg">CONTACT US</span>
            </button>
          </div>

        </div>
      </div>

      {/* Flèche du bas */}
      <button
        onClick={() => scrollToSection('certifications')}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20"
        aria-label="Scroll to next section"
      >
        <svg className="w-7 h-7 text-white/80 animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
        </svg>
      </button>
    </section>
  );
};

export default Hero;